/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const GET_GTIN_DETAIL = gql`
    query GetGtin($gtinId: String!) {
        getGtin(gtin_id: $gtinId) {
            _id
            item
            name
            from
            price
            quantity
            gtinKey
            assets {
                imgs {
                  src
                }
              }
            desc{
              val
            }
            attrs {
              name
              val
            }
            product {
                images
              }
            batches {
                name
                _id
                manufactureDate
                variants
                isLocked
                shelfLife
                createdAt
                updatedAt
            }
            updatedAt
        }
    }
`;
